import { AssessmentUI } from 'features'

const Assessment = () => {
  return (
    <div>
      <AssessmentUI/>
    </div>
  )
}

export { Assessment }